module.exports = __webpack_public_path__ + "static/media/landing_share.67289551.png";